import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { SchoolDocumentFile } from '../school-document-file';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-school-document-file-edit',
  templateUrl: './school-document-file-edit.component.html',
  styleUrls: ['./school-document-file-edit.component.css']
})
export class SchoolDocumentFileEditComponent implements OnInit {

  schoolDocuments: SchoolDocumentFile[] = [];
  pictureUploading: boolean = false;
  schoolId!: number;
  accordionIndex: number | number[] = -1;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.schoolId = Number(this.route.snapshot.paramMap.get("schoolId"));
    this.getDocumentList();
  }

  getDocumentList(){
    this.httpService.getSchoolDocumentsBySchoolId(this.schoolId).subscribe(res => {
      this.schoolDocuments = res;
    });
  }

  downloadFile(file: SchoolDocumentFile){
    this.httpService.getSchoolDocumentFile(file.id!).subscribe(blob => {
      let pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = file.name;
      link.click();  
    });
  }

  uploadFile(files: File[], form: any){
    if(files.length == 0){
      return;
    }
    this.pictureUploading = true;

    let schoolDocument = new SchoolDocumentFile(
      files[0].name,
      null
    );
    let formData = this.getFormData(schoolDocument, files);
      this.httpService.postSchoolDocumentFile(formData, this.schoolId).subscribe(() => {
        this.toastService.addSuccess("Success", "File uploaded");
        this.getDocumentList();
        form.clear();
        this.accordionIndex = -1;
      }, error => this.toastService.addError("Error", error.message));

  }

  getFormData(schoolDocument: SchoolDocumentFile, files: File[]){
    let formData = new FormData();
    if(files.length > 0){
      for(let file of files){
        formData.append("files", file, file.name);
      }
    }
    formData.append("schoolDocumentFile", new Blob([JSON.stringify(schoolDocument)], {
      type: "application/json"
    }));
    return formData;
  }

}